import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Table, Button, Badge, Row, Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

// Components
import LoadingSpinner from '../../../utils/LoadingSpinner';
import ConfirmDialog from '../../../utils/ConfirmDialog';
import DeferredElements from './DeferredElements';

// Actions
import { get_deferred_queues, retry_all_deferred, remove_deferred } from '../../../../actions/deferredActions';

const DeferredQueues = () => {
	const dispatch = useDispatch();

	const { deferred_loading, deferred_queues } = useSelector(state => state.deferred);

	const [selectedQueue, setSelectedQueue] = useState(null);
	const [retryAllShow, setRetryAllShow] = useState(false);
	const [retryAllFilters, setRetryAllFilters] = useState({});
	const [filterResource, setFilterResource] = useState('');
	const [filterSpeed, setFilterSpeed] = useState('');

	useEffect(() => {
		const filters = {};
		if (filterResource) filters.resource = filterResource;
		if (filterSpeed) filters.speed = filterSpeed;
		dispatch(get_deferred_queues(filters));
	}, [filterResource, filterSpeed]);

	const queues = Array.isArray(deferred_queues) ? deferred_queues : [];

	const handleRetryAll = (queue) => {
		const filters = { resource: queue.resource, speed: queue.speed, force: 'true' };
		if (queue.organization) filters.organization = queue.organization;
		setRetryAllFilters(filters);
		setRetryAllShow(true);
	};

	return (
		<>
			<ConfirmDialog
				show={retryAllShow}
				onHide={() => setRetryAllShow(false)}
				title='Retry All Deferred Jobs'
				message='Are you sure you want to retry all jobs in this deferred queue?'
				confirmFunction={() => {
					dispatch(retry_all_deferred(retryAllFilters));
					setRetryAllShow(false);
				}}
			/>

			<Card className='shadow-sm mb-3 card-border'>
				<Card.Body>
					<Card.Title className='text-center' as='h5'>Deferred Queues</Card.Title>

					<Row className='mb-3'>
						<Col xs={4}>
							<Form.Control
								placeholder='Filter by resource'
								value={filterResource}
								onChange={(e) => setFilterResource(e.target.value)}
							/>
						</Col>
						<Col xs={3}>
							<Form.Select value={filterSpeed} onChange={(e) => setFilterSpeed(e.target.value)}>
								<option value=''>All speeds</option>
								<option value='general'>General</option>
								<option value='common'>Common</option>
								<option value='priority'>Priority</option>
								<option value='background'>Background</option>
								<option value='backup'>Backup</option>
							</Form.Select>
						</Col>
						<Col xs={2}>
							<OverlayTrigger placement='bottom' overlay={<Tooltip>Refresh</Tooltip>}>
								<Button className='jobs-actions' onClick={() => dispatch(get_deferred_queues({}))}>
									<i className='bi bi-arrow-clockwise bi-bold fs-5'></i>
								</Button>
							</OverlayTrigger>
						</Col>
					</Row>

					{deferred_loading
						? <LoadingSpinner loadingMsg='Loading deferred queues' />
						: queues.length === 0
							? <p className='text-center text-muted'>No deferred queues found</p>
							: <Table hover responsive>
								<thead>
									<tr>
										<th>Queue</th>
										<th>Resource</th>
										<th>Speed</th>
										<th>Organization</th>
										<th>Pending</th>
										<th>Actions</th>
									</tr>
								</thead>
								<tbody>
									{queues.map((queue, idx) => (
										<tr key={idx}>
											<td>
												<Button variant='link' className='p-0' onClick={() => setSelectedQueue(selectedQueue === idx ? null : idx)}>
													<i className={`bi bi-chevron-${selectedQueue === idx ? 'down' : 'right'} me-2`}></i>
													{queue.queue || queue.deferred}
												</Button>
											</td>
											<td>{queue.resource}</td>
											<td>{queue.speed}</td>
											<td>{queue.organization || '—'}</td>
											<td><Badge bg='warning' text='dark'>{queue.pending || queue.count || 0}</Badge></td>
											<td>
												<OverlayTrigger placement='bottom' overlay={<Tooltip>Retry All</Tooltip>}>
													<Button size='sm' variant='outline-primary' className='me-2' onClick={() => handleRetryAll(queue)}>
														<i className='bi bi-arrow-repeat'></i>
													</Button>
												</OverlayTrigger>
											</td>
										</tr>
									))}
								</tbody>
							</Table>
					}
				</Card.Body>
			</Card>

			{selectedQueue !== null && queues[selectedQueue] &&
				<DeferredElements queue={queues[selectedQueue]} />
			}
		</>
	);
}

export default DeferredQueues;
